var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('NavigationCard',{attrs:{"image":"/assets/img/VIP/navigation.png","topUrl":"../../../assets/img/TopFirst/VIPTop.mp4","topUrlType":"video"}}),_c('div',{staticClass:"page_content"},[_c('RouteNav'),_c('router-view',{key:_vm.$route.fullPath})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }